module.exports = __webpack_public_path__ + "media/images/emblems/Gollion-coat_of_arms-e1a21e70b89404c7c726662aec5afdda.svg";